










































































































































































































































import { Component, Vue, Prop, Watch, InjectReactive } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import {
  GQL_ameldingsInYear,
  GQL_ameldingsInYearVariables,
  GQL_ameldingsInYear_ameldings,
} from '@/queries/__generated__/ameldingsInYear';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import uniq from 'lodash/uniq';
import AmeldingListHeader from './AmeldingListHeader.vue';
import AmeldingListPaycheck from './AmeldingListPaycheck.vue';
import AmeldingListWorkRelation from './AmeldingListWorkRelation.vue';
import { generateUID, WithUID } from '@/utils/utils';
import { sortAmeldings } from '@/app/Altinn';
import dayjs from '@/utils/dayjs';
import {
  CHECK_ALTINN3_SUBMISSION_STATUS,
  GET_ALTINN3_SUBMISSION_FEEDBACK,
  ameldingListFragments,
} from '@/queries/AltinnSubmission';
import Decimal from '@/utils/decimal';
import paycheckSettingsService from '@/utils/paycheck-settings-service';
import gql from 'graphql-tag';

 const AMELDINGS_IN_YEAR = gql`
  query ameldingsInYear($year: String!, $unitId: ID!) {
    ameldings(year: $year, unitId: $unitId) {
      ...ameldingListFragments
    }
  }
  ${ameldingListFragments}
`;

const CANCEL_ALTINN3_AMELDING = gql`
  mutation cancelAltinn3Amelding($ameldingId: ID!) {
    cancelAltinn3Amelding(
      input: {
        ameldingId: $ameldingId
      }
    ) {
      amelding {
        id
      }
    }
  }
`;


@Component({
  components: {
    AmeldingListHeader,
    AmeldingListPaycheck,
    AmeldingListWorkRelation,
  },
})
export default class AmeldingList extends Vue {
  @Prop(Object) private currentUnit!: GQL_currentUnit_currentUnit;
  @Prop({ type: [ String, Number ], default: dayjs().year() }) private year!: string | number;

  @SmartQuery<AmeldingList, GQL_ameldingsInYear, GQL_ameldingsInYearVariables>({
    query: AMELDINGS_IN_YEAR,
    fetchPolicy: 'network-only',
    variables() {
      return {
        year: String(this.year),
        unitId: this.currentUnit.id,
      };
    },
    update: data => sortAmeldings(data.ameldings).reverse(),
  }) private ameldings!: WithUID<GQL_ameldingsInYear_ameldings[]>;

  @InjectReactive() private editable!: boolean;

  private CHECK_ALTINN3_SUBMISSION_STATUS = CHECK_ALTINN3_SUBMISSION_STATUS;
  private CANCEL_ALTINN3_AMELDING = CANCEL_ALTINN3_AMELDING;
  private GET_ALTINN3_SUBMISSION_FEEDBACK = GET_ALTINN3_SUBMISSION_FEEDBACK;

  private Decimal = Decimal;

  private expandedIds: { [uid: string]: boolean } = {};
  private highlightedId: number | null = null;

  private get calendarMonths(): string[] {
    return uniq(
      this.ameldings
        .map(r => r.calendarMonth),
    )
      .sort()
      .reverse();
  }

  private reportsForMonth(calendarMonth: string): GQL_ameldingsInYear_ameldings[] {
    return this.ameldings.filter(r => r.calendarMonth === calendarMonth);
  }

  private canSendEmployerOrIncomeTax(calendarMonth: string): boolean {
    return this.reportsForMonth(calendarMonth)
      .some(r => (r.altinnSubmission || r.altinn3Submission)!.receivedFeedback && r.humanStatus !== 'REJECTED');
  }

  private printReported(amelding: GQL_ameldingsInYear_ameldings): string {
    const paycheckCount = amelding.paychecks.length;
    const wrCount = amelding.ameldingWorkRelations.length;

    const reportedPaychecks = this.$tc('Amelding.reportedPaychecks', paycheckCount, { count: paycheckCount });
    const reportedWorkRelations = this.$tc('Amelding.reportedWorkRelations', wrCount, { count: wrCount });
    return this.$t('Amelding.reportedPaychecksandWorkRelations', { reportedPaychecks, reportedWorkRelations }) as string;
  }

  private paycheckSettingsService = paycheckSettingsService;

  @Watch('ameldings', { deep: true })
  private assignExpandableIds(): void {
    this.ameldings.forEach((value: GQL_ameldingsInYear_ameldings) => {
      const report = value as WithUID<GQL_ameldingsInYear_ameldings>;
      report.$_UID = generateUID();
      this.$set(this.expandedIds, report.$_UID, false);
    });
  }

  private highlightPaycheck(id: number): void {
    this.highlightedId = id;
  }

  private reportAppearActive(report: GQL_ameldingsInYear_ameldings): boolean {
    return (
      (!report.ameldingToReplace && !report.replacementAmelding) ||
      [ 'PENDING', 'FEEDBACK_READY', 'SUCCESSFUL' ].includes(report.humanStatus)
    );
  }

  private submission(report: GQL_ameldingsInYear_ameldings) {
    return report.altinnSubmission || report.altinn3Submission!;
  }
}
